import Loandetailspendingview from "../../../jsx/components/Dashboard/LoanDetails/loandetailspendingview";

const LoanDetailsPendingViewWrapper = () => {
  return <Loandetailspendingview />;
};

export default constore(LoanDetailsPendingViewWrapper);
